import React from "react";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import OptimumFrictionReportGrid from "./views/OptimumFrictionReportGrid";

export default function OptimumFrictionReportWrapper() {
     return (
          <>
               <MainLeftTitle title="Optimum Friction Report" />

               <OptimumFrictionReportGrid />
          </>
     );
}
